module.exports = __webpack_public_path__ + "static/media/panorama_obrez.ccbcd803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/panorama_obrez.jpg
// module id = 637
// module chunks = 0